import * as React from 'react'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { ListItemIcon, ListItemText } from '@mui/material'

const ITEM_HEIGHT = 48

const DropdownMenu = ({ options = [], onSelect = () => {} }) => {
	const [anchorEl, setAnchorEl] = React.useState(null)
	const open = Boolean(anchorEl)

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	const handleSelect = (option) => {
		onSelect(option)
		handleClose()
	}
	const menu_style = {
		marginTop: '8px',
		'& .MuiPaper-root': {
			boxShadow: '0px 0px 4px 0px #00000040',
			border: '1px solid #DFE4EB',
			borderRadius: '12px',
			minWidth: '100px',
			width: 'max-content !important',
		},
		'& .MuiList-root': {
			padding: '6px 0 !important',
		},
		'& .MuiTypography-root': {
			fontSize: '14px',
			fontWeight: '500',
			color: '#313131',
			fontFamily: 'Inter',
			textTransform: 'capitalize',
		},
		'& .MuiListItemIcon-root': {
			minWidth: '20px !important',
			width: '20px !important',
			height: '20px !important',
			marginRight: '8px',
		},
		'& .MuiDivider-root': {
			margin: '0 !important',
		},
	}
	return (
		<>
			<IconButton
				aria-label="menu"
				aria-controls={open ? 'dropdown-menu' : undefined}
				aria-haspopup="true"
				onClick={handleClick}
				disableRipple
			>
				<img src="/images/more.svg" alt="" />
			</IconButton>
			<Menu
				id="dropdown-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				slotProps={{
					paper: {
						style: {
							maxHeight: ITEM_HEIGHT * 4.5,
							width: '20ch',
						},
					},
				}}
				sx={menu_style}
			>
				{options.map((option) => (
					<MenuItem key={option} onClick={() => handleSelect(option)}>
						{option.icon && (
							<ListItemIcon
								sx={
									option.color
										? { color: option.color }
										: undefined
								}
							>
								{option.icon}
							</ListItemIcon>
						)}
						<ListItemText>{option.label}</ListItemText>
					</MenuItem>
				))}
			</Menu>
		</>
	)
}

export default DropdownMenu
